import { toast } from "react-toastify";
import { log } from "../../Helper";
import { getAccessToken } from "../../utils/okta-config";
import { API_ROOT } from "../../constants/constants";

export const PostAvisData = (
  reqObj,
  acceptedFiles,
  setStartSpinner,
  avisLoadBuildValidateAction,
  triggerLoadBuildActionByAvis,
  setSpinnerState
) => {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/forwarder/updateLoadBuild`;
  let formData = new FormData();
  formData.append(
    "jsonBodyData",
    new Blob([JSON.stringify(reqObj)], {
      type: "application/json",
    })
  );
  log("file selected", acceptedFiles);
  for (let i = 0 ; i < acceptedFiles.length ; i++) {
    formData.append("file", acceptedFiles[i]);
  }

  const requestOptions = {
    method: "POST",
    body: formData,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
    },
  };

  fetch(url, requestOptions)
    .then((result) => result.text())
    .then((response) => {
      const respObj = JSON.parse(response);
      log("response ", respObj);
      if (respObj["httpResponse"] === 200) {
        setSpinnerState(false);
        toast.success(respObj["message"]);
        setStartSpinner(false);
        avisLoadBuildValidateAction(true);
        triggerLoadBuildActionByAvis(false);
      } else if (respObj["httpResponse"] === 206) {
        setSpinnerState(false);
        toast.warn(respObj["message"]);
        setStartSpinner(false);
        avisLoadBuildValidateAction(true);
        triggerLoadBuildActionByAvis(false);
      } else {
        setSpinnerState(false);
        toast.error(respObj["message"]);
        setStartSpinner(false);
        avisLoadBuildValidateAction(true);
        triggerLoadBuildActionByAvis(false);
      }
    });
};
